<template xmlns:v-if="http://www.w3.org/1999/XSL/Transform">
  <svg-b-event @click="svgbClick" :icon-color="iconColor" :width="width" :height="height" :sign="sign" :push-color="pushColor" contentszoom="none" ref="eventer">
  	<template v-if="html != 'use'" >
	  <text
			  id="Button"
			  :[vdFont]="font"
			  :[vdFontSize]="fontsize"
			  :[vdFontWeight]="fontweight"
			  fill="currentColor"
			  x="50%"
			  :y="centerHeight"
			  text-anchor="middle"
			  dominant-baseline="middle"
			  pointer-events="none"
	  >
		  <slot>Button</slot>
	  </text>
	</template>
	<slot v-else>
		<template>
			<text
			  id="Button"
			  fill="currentColor"
			  x="50%"
			  :y="centerHeight"
			  text-anchor="middle"
			  dominant-baseline="middle"
			  pointer-events="none"
			>
				Button
			</text>
		</template>
	</slot>
  </svg-b-event>
</template>

<script>
import SVGBMouseEvent from "@/components/SVGBMouseEventSlot";
export default {
  name: "SVGBTextButton",
  components: {
    SvgBEvent: SVGBMouseEvent
  },
  props: {
	width: {
		type: [Number, String],
		default: 80
	},
	height: {
		type: [Number, String],
		default: 40
	},
	sign: {
		type: String,
		default: "none"
	},
	contentszoom: {
		type: String,
		default: null
	},
	font: {
      type: String,
      default: null
    },
	fontsize: {
	  type: Number,
	  default: 0
	},
	fontweight: {
	  type: String,
	  default: null
	},
	html: {
	  type: String,
	  default: null
	},
    pushColor: {
	  type: String,
      default: null
    },
  },
  data: function() {
  	return {
      isDisable: false,
      pxwidth: 80,
      pxheight: 40,
	}
  },
  watch: {
	isDisable: function (nv,ov) {
	  this.$refs.eventer.isDisable = nv;
			//Vue.set(this.$refs.eventer,'isDisable',nv);
	},
  },
  computed: {
    iconColor: function() { return this.defUIIconColor; },
	vdFont: function () { return this.font == null ? null : "font-family"; },
	vdFontSize: function () { return !this.fontsize ? null : "font-size"; },
	vdFontWeight: function () { return this.fontweight== null ? null : "font-weight"; },
    centerHeight () { return (this.pxheight / 2) + (this.fontsize / 8); },
  },
  mounted() {
    this.$nextTick(() => {
      this.pxwidth = this.$el.clientWidth
      this.pxheight = this.$el.clientHeight
    })
  },
  methods: {
    svgbClick: function() {
      this.$emit("click")
    }
  }
};
</script>

<style scoped></style>
